<template>
    <div class="d-flex align-items-center mr-2 mb-2">
        <animal-avatar :thumbnail-absolute-path="getDescriptionObject['thumbnail']"
           :species="getDescriptionObject['species']" class="m-1" :size="42"/>
        <div class="d-flex flex-column">
            <b-link :to="{ name: 'animalDetail', params: { id: getDescriptionObject['id'] } }" class="d-flex flex-column">
                <span>
                    <span>№{{ getDescriptionObject['reg_number'] }}</span><span v-if="getDescriptionObject['shelter_reg_number']">, рег. №{{ getDescriptionObject['shelter_reg_number'] }}</span>
                </span>
                <span>{{ getDescriptionObject['species_name'].toLowerCase() }}, {{ getDescriptionObject['breed_name'].toLowerCase() }}</span>
            </b-link>
            <small class="text-secondary">{{ getAnimalLowercaseGender(animal) }}, {{ getDescriptionObject['chip_id'] }}, {{ getDescriptionObject['label_id'] }}</small>
        </div>
    </div>
</template>

<script>
import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar.vue";

export default {
    name: "AnimalLink",
    components: {AnimalAvatar},
    props: {
        animal: { type: Object, default: () => { return {} } }
    },
    computed: {
        getDescriptionObject() {
            if (this.animal.hasOwnProperty('descriptionObject')) {
                return this.animal.descriptionObject
            }
            if (this.animal.hasOwnProperty('description_object')) {
                return this.animal['description_object']
            }
            return {}
        }
    },
    methods: {
        getAnimalLowercaseGender() {
            const descriptionObject = this.getDescriptionObject;
            return descriptionObject['gender_name'] ? descriptionObject['gender_name'].toLowerCase() : 'пол не указан'
        },
    }
}
</script>

<style scoped>

</style>